/*
 * @Author: wsx
 * @Date: 2022-01-19 10:49:35
 * @LastEditTime: 2022-01-19 15:59:43
 * @LastEditors: your name
 * @Description:
 */
import request from "@/utils/request";

// 获取字典类型列表
export const queryDictList = data => {
  return request({
    url: "/api/hz-smart-community/sys/dict/list",
    params: data || {}
  });
};
// 获取字典数据
export const getDict = data => {
  return request({
    url: "/api/hz-smart-community/sys/dict/getDict/" + data
  });
};

// 添加典数据
export const dictSave = data => {
  return request({
    url: "/api/hz-smart-community/sys/dict/save",
    data: data || {},
    method: "POST"
  });
};

// 更新典数据
export const dictUpdate = data => {
  return request({
    url: "/api/hz-smart-community/sys/dict/update",
    data: data || {},
    method: "POST"
  });
};

// 更新典数据
export const dictDelete = data => {
  return request({
    url: "/api/hz-smart-community/sys/dict/delete",
    data: data || {},
    method: "POST"
  });
};

// 详细地址选择
export const infoSelect = data => {
  return request({
    url: "/api/hz-smart-community/house/info/select",
    params: data || {}
  });
};
